import { type HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

export type BadgeProps = HTMLAttributes<HTMLDivElement>

export function Badge({ className, ...props }: BadgeProps) {
  return (
    <div
      className={cn('inline-flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2', className)}
      {...props}
    />
  )
}
Badge.displayName = 'Badge'
